import type { WithActiveBranchId } from '@app/api/shared';

export enum SocialIntegrationEmailParsingRuleEndpoints {
  SocialIntegrationEmailParsingRuleUpdate = 'SocialIntegrationEmailParsingRuleUpdate',
  SocialIntegrationEmailParsingRuleList = 'SocialIntegrationEmailParsingRuleList',
}

export interface ModelSocialIntegrationEmailParsingRule {
  SourceEmailsList: string[] | null;
  IsOn: boolean;
  CheckSpam: boolean;
  ExtractFullName: boolean;
  ExtractPhone: boolean;
  ExtractGender: boolean;
  ExtractLanguage: boolean;
  ExtractEmail: boolean;
  AssignTagIds: number[] | null;
  TagExtractionKeywordList: string[] | null;
  FixedTagIds: number[] | null;
}

export interface ModelTagIdName {
  Id: number;
  Name: string | null;
}

export interface ModelSocialIntegrationEmailParsingRuleWithTags {
  Id: number;
  SourceEmailsList: string[] | null;
  IsOn: boolean;
  CheckSpam: boolean;
  ExtractFullName: boolean;
  ExtractPhone: boolean;
  ExtractGender: boolean;
  ExtractLanguage: boolean;
  ExtractEmail: boolean;
  AssignTags: ModelTagIdName[] | null;
  TagExtractionKeywordList: string[] | null;
  FixedTags: ModelTagIdName[] | null;
}

export interface ModelSocialIntegrationEmailParsingRuleArray {
  SocialIntegrationId: number;
  Rules: ModelSocialIntegrationEmailParsingRule[];
}

export interface ModelSocialIntegrationEmailParsingRuleListResponse {
  SocialIntegrationId: number;
  Rules: ModelSocialIntegrationEmailParsingRuleWithTags[] | null;
  SocialIntegrationName: string | null;
  TimeCreated: string | null;
}

export type SocialIntegrationEmailParsingRuleUpdateRequest =
  WithActiveBranchId<{
    data: ModelSocialIntegrationEmailParsingRuleArray;
  }>;

export type SocialIntegrationEmailParsingRuleListRequest = WithActiveBranchId<{
  socialIntegrationId: number;
}>;

export type SocialIntegrationEmailParsingRuleUpdateResponse =
  ModelSocialIntegrationEmailParsingRule[];

export type SocialIntegrationEmailParsingRuleListResponseData =
  ModelSocialIntegrationEmailParsingRuleListResponse;
